export default {
    global: {
        close: 'Sluiten',
        save: 'Opslaan',
        continue : 'Doorgaan',
        confirmAndSend: 'Bevestigen en verzenden',
        mandatory_field: 'Dit veld is verplicht',
        checkbox_mandatory : 'Dit selectievakje is vereist',
        cancel: 'Annuleren',
        ok: 'ok',
        yes: 'Ja',
        no: 'Nee',
        post_success: 'Data goed verzonden.',
        code : 'CODE:'
    },
    menu: {
        main_menu: 'Hoofdmenu',
        lmra: 'Open/Sluit LMRA',
        report_incident: 'Incident melden',
        report_near_incident: 'Bijna-incident melden',
        risk_analysis: 'Risico analyse',
        corona_analysis: 'Corona analyse',
        scan_qr: "Scan TAG/QR-CODE",
        process_issue: "Proces probleem melden",
        checklist: "Bekijk checklist",
        log_in: "Aanmelden",
        log_out: "Afmelden",
        emergency_numbers : "Noodnummers",
        project_documentation : "Project Documentatie"
    },
    default_lrma: {
        what_label: 'Begrijp ik wat ik moet doen?',
        how_label: 'Weet ik hoe ik het moet doen?',
        risks_label: 'Herken ik de gevaren en Risico’s?',
        control_label: 'Kan ik deze beheersen?',
        default_pbm_label: 'Beschik ik over de juiste PBM ?',
        default_pbm_question: 'Beschik ik over de juiste PBM ?|1',
        lmra_job_state_positive: 'Ok om de werken te starten, bij veranderingen herbekijken we de LMRA',
        lmra_job_state_negative: 'Wij starten de werken nog niet.',
    },
    static_three_state_lmra: {
        getting_data_title: "De laatste versie word opgehaald.",
        could_not_load_newest_list_title: 'Opgelet.',
        could_not_load_newest_list: 'Er is iets fout gegaan tijdens het ophalen van de nieuwste lijst. Een oudere opgeslagen versie van de lijst word weergegeven zodat je alsnog kan verder gaan. Indien dit probleem zich blijft voordoen brengt u best een verantwoordelijke op de hoogte.',
    },
    private_location: {
        title: 'Bevindt u zich op een privé locatie?',
        body: 'Privé locaties zijn locaties buiten het werk gerelateerde plaatsen.'
    },
    remarks: {
        remarksDialogTitle: 'Opmerkingen?',
        remarksDialogPlaceholder: 'Typ hier je opmerkingen',
    },
    start_stop_screen: {
        start_work_btn: "starten met werken",
        stop_work_btn: "stoppen met werken",
    },
    work_report: {
        title: "Werkverslag",
        placeholder: "Typ hier je werkverslag",
        skip_work_report: "Overslaan",
        buildingListTitle : "We bouwen uw werkverslag-formulier, dit zou niet al te lang mogen duren.",
        criticalErrorTitle: 'Fout:',
        criticalErrorBody: 'Er is iets misgegaan bij het maken van uw werkverslag-formulier! geef uw manager de onderstaande foutcode door: ',
    },
    incident_report: {
        title: "Rapporteer incident",
        placeholder: "Wat is er gebeurd?",
    },
    oeps_report: {
        title: "Rapporteer incident",
        placeholders: {
            machine: 'Welke machine?',
            who: 'Wie was er betrokken?',
            what: 'Wat is er gebeurd?',
            how: 'Hoe is dit gebeurd / hoe kon dit gebeuren?',
            stop_card: 'Selecteer Stopcard',
            location: 'Selecteer locatie',
            department: 'Selecter departement'
        },
        external_employee: 'Is externe medewerker',
        when_text_label: 'Wanneer is dit gebeurd?',
        change_date_time_btn: 'Wijzig datum/tijd'
    },
    risk_analysis: {
        title: {
            risk_default: "Risico Analyse",
            risk_default_sub_title: '',
            corona: "Corona Analyse",
            corona_sub_title: 'Geef hieronder uw arbeidsomstandigheden aan en ontdek hoe u veilig kunt werken.'
        },
        lists: {
            risk_default: {
                gravity: {
                    label: 'Ernst',
                    gravity_01: 'gering, letsel zonder verzuim',
                    gravity_02: 'belangrijk, letsel en verzuim',
                    gravity_07: 'ernstig, blijvende invaliditeit/chronische aandoeningen met (gedeeltelijke) arbeidsongeschiktheid',
                    gravity_15: 'zeer ernstig, 1 dode (acuut op termijn)',
                    gravity_40: 'ramp, meerdere doden'
                },
                probability: {
                    label: 'Waarschijnlijkheid / kans',
                    probability_0_1: 'bijna niet denkbaar',
                    probability_0_2: 'praktisch onmogelijk',
                    probability_0_5: 'denkbaar, maar onwaarschijnlijk',
                    probability_01: 'onwaarschijnlijk, grensgeval',
                    probability_03: 'ongewoon, maar mogelijk',
                    probability_06: 'goed mogelijk',
                    probability_10: 'te verwachten'
                },
                exposure: {
                    label: 'Blootstelling',
                    exposure_0_5: 'zeer zelden (1x per jaar)',
                    exposure_01: 'zelden (jaarlijks)',
                    exposure_02: 'soms (maandelijks)',
                    exposure_03: 'af en toe (wekelijks)',
                    exposure_06: 'regelmatig (dagelijks)',
                    exposure_10: 'voortdurend',
                },
            },
            corona: {
                distance: {
                    label: 'Verwachte afstand tussen mij en anderen:',
                    distance_01: 'A > 8 m',
                    distance_02: '6 m < A < 8 m',
                    distance_07: '2 m < A < 6 m',
                    distance_15: '1,5 m < A < 2 m',
                    distance_40: '1 m < A < 1,5 m',
                    distance_100: 'A < 1 m'
                },
                probability: {
                    label: 'Ik merk dat anderen ...',
                    probability_0_1: 'een FFP2 masker + bril + beschermkledij dragen',
                    probability_0_2: 'een FFP2 masker + bril dragen',
                    probability_0_5: 'een masker of gelaatsscherm dragen',
                    probability_01: 'zeker de Coronarichtlijnen respecteren',
                    probability_03: 'misschien de Coronarichtlijnen respecteren',
                    probability_06: 'sommige Coronarichtlijnen overtreden',
                    probability_10: 'meerdere Coronarichtlijnen overtreden'
                },
                exposure: {
                    label: 'Kans op dichter contact dan verwacht:',
                    exposure_0_5: 'Zeer onwaarschijnlijk',
                    exposure_01: 'Als er verschillende dingen mislopen',
                    exposure_02: 'Ongewoon, als bepaalde dingen mislopen',
                    exposure_03: 'Mogelijk, kans is niet zo groot',
                    exposure_06: 'Goed mogelijk, redelijke kans',
                    exposure_10: 'Te verwachten, bijna zeker',
                },
            },
        },
        results: {
            risk_default: {
                kinneyCode1: 'geen',
                kinneyCode2: 'aandacht vereist',
                kinneyCode3: 'maatregelen vereist, kan gepland worden',
                kinneyCode4: 'directe verbetering',
                kinneyCode5: 'werken stoppen'
            },
            corona: {
                kinneyCode1: 'Aanvaardbaar risico: Geen extra beschermende maatregelen nodig',
                kinneyCode2: 'Mogelijk risico: Aandacht nodig',
                kinneyCode3: 'Belangrijk risico: Beschermende maatregelen nemen',
                kinneyCode4: 'Hoog risico: Verhoogde beschermende maatregelen nemen',
                kinneyCode5: 'Zeer hoog risico: Probeer activiteit aan te passen, indien onmogellijk dan maximale beschermende maatregelen nemen'
            },
        },
        supportive_texts: {
            risk_default: {
                supportiveText1: '',
                supportiveText2: '',
                supportiveText3: '',
                supportiveText4: '',
                supportiveText5: ''
            },
            corona: {
                supportiveText1: 'Ik ken en respecteer de Coronarichtlijnen die van toepassing zijn in mijn werkomgeving.',
                supportiveText2: 'Ik ken en respecteer de Coronarichtlijnen die van toepassing zijn. Ik vraag uitdrukkelijk aan de personen in mijn werkomgeving  om ook de Coronarichtlijnen na te leven. Er zijn geen verdere extra beschermende maatregelen nodig.',
                supportiveText3: 'Ik was of ontsmet handen bij aanvang en beëindiging van de activiteit. Ik draag een  gelaatsscherm of een geschikt mondmasker in combinatie met een (veiligheids)bril. De personen in mijn werkomgeving  moeten minstens ook een  gelaatsscherm  of een mondneusmasker  (bij voorkeur samen met een veiligheidsbril) dragen. Ik weet hoe deze collectieve beschermingsmiddelen correct te gebruiken en pas dit in de praktijk toe.  Ik ken en respecteer de Coronarichtlijnen die van toepassing zijn en ik vraag uitdrukkelijk aan de personen in mijn werkomgeving  om ook de Coronarichtlijnen na te leven.',
                supportiveText4: 'Ik was of ontsmet handen bij bij aanvang en beëindiging van de activiteit en na elke onveilige aanraking. Ik draag een beschermend mondneusmasker (bij voorkeur een FFP2 ademhalingsbeschermingsmasker) in combinatie met een gelaatsscherm of beschermende bril. Ik weet hoe deze persoonlijke beschermingsmiddelen (PBM) correct te gebruiken en pas dit in de praktijk toe. Ik ken de coronarichtlijnen die van toepassing zijn in de werkomgeving en blijf natuurlijk deze Coronarichtlijnen respecteren. Ik vraag aan personen in mijn werkomgeving om ook de nodige veiligheidsmaateregelen te nemen en de Coronarichtlijnen na te leven.',
                supportiveText5: 'Ik bekijk eerst of de activiteit op een andere manier zonder direct contact met andere personen kan uitgevoerd worden. Indien dit niet mogelijk is, neem ik alle mogelijke veiligheidsmaatregelen. Ik was of ontsmet handen bij aanvang en beëindiging van de activiteit. Ik draag beschermende handschoenen. Ik draag een ademhalingsbeschermingsmasker (minstens FFP2) in combinatie met een gelaatsscherm of beschermende bril en beschermende kledij. Ik weet hoe deze persoonlijke beschermingsmiddelen (PBM) correct te gebruiken en pas dit in de praktijk toe.  Ik ken de coronarichtlijnen die van toepassing zijn in de werkomgeving en blijf natuurlijk deze Coronarichtlijnen respecteren.. Ik vraag aan personen in mijn werkomgeving om ook de nodige veiligheidsmaateregelen te nemen en de Coronarichtlijnen nouwlettend na te leven.'
            }
        },
        leave_warning: {
            risk_default: {
                title: 'Opgelet',
                body: 'U staat op het punt dit venster te sluiten zonder het huidige risicoanalyserapport te verzenden. Weet je zeker dat je wilt de pagina verlaten?'
            },
            corona: {
                title: 'Opgelet',
                body: 'U staat op het punt dit venster te sluiten zonder het huidige Corona-analyserapport te verzenden. Weet je zeker dat je wilt de pagina verlaten?'
            }
        },
        report_title: 'Analyse verslag',
        placeholder_report: 'Omschrijf / verduidelijk de situatie'
    },
    process_issue: {
        title: "Meld een Proces probleem",
        placeholders: {
            issue_type_select: 'Selecteer probleem type',
            failure_detail: 'Selecter probleem detail',
            who: 'Wie was er betrokken?',
            description: 'Omschrijf het probleem',
            cnf: 'CNF?',
            comment: 'Bijkomende commentaar / omperkingen',
            other: 'Andere'
        }
    },
    checklist: {
        getting_data_title: "De laatste checklist word opgehaald."
    },
    data_transfer: {
        post_busy: 'Even geduld, de gegevens worden verstuurd.',
        post_success: 'Data Goed verzonden.'
    },
    gdpr_disclaimer: {
        title: 'GDPR voorstel',
        body: 'Bij het indienen van een item van de lmra-first applicatie worden de volgende items in de database opgeslagen: huidige locatie (GPS - coördinaten (na bevesitging)) en de exacte tijd (en alleen op dat moment). Geen van deze items wordt verkocht aan andere partijen, organisaties. De opgeslagen gegevens worden alleen gebruikt in volgorde van het project en de bijbehorende arbeidsomstandigheden',
        accept_btn : 'Akkoord',
        decline_btn : 'Verlaat App.'
    },
    data_notice: {
        button_text: 'Wat gebeurt er met deze informatie?',
        popup_title: '',
        popup_body: ''
    },
    cap_settings : {
        alert_cn_pid_nf_title : 'Oeps zo te zien ben je iets vergeten:',
        alert_cn_pid_nf_body : 'Klantnaam en / of project-ID niet ingevuld, controleer de waarden',
        client_select_placeholder : 'Selecteer een klant',
        project_select_placeholder : 'Selecteer een project',
        client_not_in_list_label : 'Klant niet in lijst',
        project_not_in_list_label : 'Project niet in lijst',
        client_name : 'Klantnaam',
        project_id : 'Project-ID',
        project_distance : 'Project afstand',
        project_shift : 'Project Shift',
        user_initials : 'Jouw initialen',
        project_tag_code_label : 'Project TAG-Code',
        warning : {
            intro : 'U gebruikt nu handmatige invoer voor',
            reason_server :'omdat servergegevens niet konden worden geladen!',
            reason_client_not_listed :'omdat de klant niet in de huidige lijst stond!',
            reason_project_not_listed :'omdat project niet in de huidige lijst stond!',
            dbl_check : 'Controleer al uw waarden voordat u opslaat!',
            admin_msg : 'Als dit bericht blijft verschijnen, neem dan contact op met uw administrator en meld dit!'
        },
        input_errors : {
            no_client_selected : 'Selecteer een klant',
            no_project_selected : 'Selecteer een project',
        },
        loading_cap : 'Gegevens laden van server',
        custom_shifts_labels: {
            open_field : 'Open veld'
        },
        rrqrcode:{
            scan_error_invalid_format : {
                title : "Scanfout",
                body: "Ongeldig QR-gegevensformaat gedetecteerd"
            },
            error_popup_notice_manual_mode : {
                title : "Er is iets misgegaan",
                body : "Er is iets misgegaan tijdens het laden van RRQRCode-gegevens en het overschakelen naar de handmatige modus"
            }
        }
    },
    tag_code_scanner: {
        global: {
            loading_stream: 'Camera stream laden ...',
            default_error_button_test : 'Sluiten'
        },
        overlay_view: {
            title : 'Scan TAG - Code',
            info_manual : 'Heeft u problemen met scannen? Gebruik handmatige invoer',
            manual_btn : 'Schakel handmatige invoer in.',
            errors : {
                invalid_tag_title : 'Ongeldige TAG-CODE',
                invalid_tag_body : 'De code die je hebt gescand is geen geldige TAG-CODE, scan een geldige TAG-CODE of schakel over naar handmatige invoer.',
                error_btn_txt : 'Handmatige invoer inschakelen'
            }
        }
    },
    errors: {
        checklistNotLoaded: 'Er is iets fout gegaan tijdens het ophalen van de lijst, probeer het later nog eens.',
        EmergencyNumbersOverviewNotLoaded: 'Er is iets fout gegaan tijdens het ophalen van de lijst, probeer het later nog eens.',
        missing_critical_resource_title: 'Fout tijdens laden van de data:',
        missing_critical_resource: 'Er ontbreekt een bron in de toepassing. Meld de onderstaande code aan de beheerder.',
        app_corrupt: 'Het lijkt erop dat de toepassingsconfiguratie is beschadigd. Neem contact op met uw beheerder.',
        data_save_failed: 'De data kon niet worden verstuurd, probeer het later nog eens...',
        camera: {
            NotAllowedError: 'FOUT: u moet toestemming voor cameratoegang verlenen',
            NotFoundError: 'FOUT: geen camera op dit apparaat',
            NotSupportedError: 'FOUT: beveiligde context vereist (HTTPS, localhost)',
            NotReadableError: 'FOUT: wordt de camera al gebruikt?',
            OverconstrainedError: 'FOUT: geïnstalleerde camera\'s zijn niet geschikt',
            StreamApiNotSupportedError: 'FOUT: Stream API wordt niet ondersteund in deze browser',
        },
        no_internet: 'Oooops ... je bent Offline, controleer je internet verbinding!',
        input_validation : {
            char_limit : 'Er zijn maximaal %n tekens toegestaan'
        },
        auth0 :{
            unverified_email : {
                error: 'Fout: e-mailadres is niet geverifieerd! Bekijk je emails!',
                info : 'Om toegang te krijgen tot deze applicatie <b>moet u uw e-mailadres verifiëren</b>.<br/><br/>U zult binnenkort <b>een e-mail ontvangen</b> <b >van |SENDER| </b><br/><br/><i>Om uw e-mailadres te verifiëren. Volg de instructies in de e-mail</i>'
            }
        }
    },
    noDataText: "Data niet beschikbaar ...",
    defaultDynamicQuestion : '{"dynamic_questions":[{"id":null,"question":"Heb ik de juiste BPM om deze job uit te voeren?","correct_answer":"1"}]}',
    auth : {
        emailLabel: 'E-mail',
        passwordLabel : 'Wachtwoord',
        rememberMeLabel : "Onthoud mij",
        logInBtn: "Aanmelden",
        logOutBtn: "Afmelden",
        verifyMFABtn : "Verifiëren",
        errorPopupTitle : "Fout",
        confirmIdentify : "Nog steeds jij?",
        errors :{
            required : "Vereist",
            invalidEmail : "Ongeldige e-mail",
            unknownError: "Er is een onbekende fout opgetreden"
        },
        registerNewAccountBtn : "Maak een nieuwe account aan.",
        forgotPassword : "Wachtwoord vergeten"
    },
    lmraComponent : {
        loadingProjectData : 'Uw LMRA-formulier wordt voorbereid, een ogenblik geduld',
        startWorkQrDialog:{
            title : "Selecteer startmethode:",
            body : "Als u over een Risk-reflex QR-code beschikt, selecteer dan de QR-code, anders gebruikt u de handmatige invoermethode",
            positive_btn: "QR-code",
            negative_btn: "Handmatige methode"
        },
        errors : {
            unknownError : "Er is een onbekende fout opgetreden",
            noListDataFound : "Fout: GEEN LIJST GEGEVENS GEVONDEN!! VAL TERUG NAAR STANDAARD LMRA",
            noDefaultListFound: 'Geen standaardlijst beschikbaar! DEFAULT LMRA gebruiken!',
        }
    },
    customLmraLists : {
        buildingListTitle : "Uw LMRA-formulier bouwen, dit zou niet al te lang moeten duren.",
        criticalErrorTitle: 'Fout:',
        criticalErrorBody: 'Er is iets misgegaan bij het maken van uw LMRA-formulier! We gaan nu de standaard LMRA laden! geef uw manager de onderstaande foutcode door: ',
    },
    workSessions :{
        global : {
            expiredLabel : "Verlopen"
        },
        resumeSessionDialog : {
            titleActiveSession : "Actieve sessie gevonden",
            titleActiveSessionExpired : "(Verlopen) actieve sessie gevonden",
        },
        workSessionServiceNaDialog :{
            title : 'WERKSESSIE SERVICE NIET BESCHIKBAAR',
            body : 'Sorry, we kunnen niet bepalen of je een open sessie hebt<br/><br/>' +
                '<b>LMRA Module is vergrendeld: u kunt geen sessie starten of afsluiten. </b><br/> U kunt echter nog steeds incidentrapporten verzenden (buiten sessie)<br/>' +
                'U ontvangt een melding wanneer de sessieservice beschikbaar is<br/><br/>' +
                'Als deze fout zich blijft voordoen, neem dan contact op met uw beheerder..'
        },
        lmraLocked : {
            lmraComponentLockedInfo : "Sorry: <b>De LMRA-module is momenteel vergrendeld: u kunt geen sessie starten of sluiten. </b>"
        },
        lmraVariants : {
            errors : {
                saving_session : {
                    missing_session_data : 'Serverantwoord bevat geen sessiegegevens',
                    could_not_save_session : 'Kan sessiegegevens niet lokaal opslaan...',
                    invalid_session_data : 'Sessiegegevens ongeldig, gegevens zijn mogelijk beschadigd'
                }
            }
        }
    },
    whatsAppGroup : {
        errors : {
            unknown : "Er is een onbekende fout opgetreden",
            notFound : "Geen groepscode gevonden."
        }
    },
    emergency_numbers: {
        default_number_btn_txt : "Standaard noodnummer",
        getting_data_title: "Laatste nummers ophalen"
    },
    checklist_components :{
        main_checklist_component : {
            tabs : {
                active_checklist : "Actieve checklist",
                other_checklists : "Andere checklists"
            }
        },
        checklist_detail_component : {
            toolbar:{
                title : "U Bekijkt :"
            },
            warning_message : "U bekijkt een checklist die niet de huidige actieve lijst is. Om de actieve lijst te bekijken, gebruikt u het tabblad \"Actieve checklist\" bovenaan"
        }
    },
    version_info : {
        update : {
            version_up_to_date : "Versie is up-to-date",
            version_minor_update : "Nieuwere versie beschikbaar (mogelijk niet beschikbaar voor uw tenant)",
            update_required : "Waarschuwing! Deze app is verouderd, de app zou automatisch moeten worden bijgewerkt. Als dit bericht blijft bestaan, neem dan contact op met de beheerder."
        }
    },
    risk_reflex_qr_code_scanner : {
        overlay_view : {
            errors : {
                wrong_qr_code_type : {
                    title : "Verkeerd QR-codetype",
                    body: "Dit QR-codetype wordt hier niet ondersteund"
                },
                wrong_tenant : {
                    title: "Verkeerde huurder",
                    body : "Deze QR-code kan niet door uw bedrijf worden gebruikt"
                },
                invalid_qr_code : {
                    title : "Ongeldige QR-code",
                    body : "Dit is geen geldige Risk Reflex QR-code en kan niet worden gebruikt"
                },
                invalid_qr_data : {
                    title : "Ongeldige QR-codegegevens",
                    body : "Deze QR-code kan niet worden vertaald, de QR-code is mogelijk beschadigd"
                }
            },
            title : "Scan de Risk-Reflex QR-Code",
            info_manual : 'Heeft u problemen met scannen? Gebruik handmatige invoer',
            manual_btn: "Schakel over naar manuele modus"
        }
    },
    project_documentation: {
        documentation_list : {
            getting_data_title : "De projectdocumentatie ophalen van de server.",
            no_documentation_found : "Kan geen documentatie vinden voor dit project.",
            errors : {
                could_not_load_documentation : "Er is iets misgegaan bij het ophalen van de documentatie. Probeer het later opnieuw."
            }
        }
    }
}